var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SvgIcon from '../svg-icon';
export var Close = function (props) { return (
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, __assign({ viewBox: "0 0 1000 1000" }, props),
    React.createElement("path", { fill: "currentColor", d: "M594.1 500l376.4 376.4c26 26 26 68.1 0 94.1s-68.1 26-94.1 0L500 594.1 123.6 970.5c-26 26-68.1 26-94.1 0s-26-68.1 0-94.1L405.9 500 29.5 123.6c-26-26-26-68.1 0-94.1s68.1-26 94.1 0L500 405.9 876.4 29.5c26-26 68.1-26 94.1 0s26 68.1 0 94.1L594.1 500z" }))); };
export default Close;
